/* eslint-disable newline-after-var */

import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import clientApi from '../../../utils/api/client';
import { Modal } from '@stormwater-software/lib-ui';

interface CustomDocTypesSectionProps {
  clientId: number;
  fetchCustomDocTypes: () => Promise<any>;
  customDocTypes: any[];
}

const CustomDocTypesSection: React.FC<CustomDocTypesSectionProps> = ({ clientId,fetchCustomDocTypes,customDocTypes }) => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [newDocTypeName, setNewDocTypeName] = useState('');
  const [selectedDocType, setSelectedDocType] = useState<any>(null);
  const [editDocTypeName, setEditDocTypeName] = useState('');



  useEffect(() => {
    fetchCustomDocTypes()
  }, [clientId]);

  const handleAddCustomDocType = async () => {
    if (!newDocTypeName.trim()) {
      toast.error('Please enter a document type name');
      
return;
    }

    try {
      await clientApi.addNewClientDocTypes.index(clientId, { name: newDocTypeName.trim() });
      await fetchCustomDocTypes()
      await 
      toast.success('Custom document type added successfully');
      setShowAddModal(false);
      setNewDocTypeName('');
    } catch (error) {
      console.error('Error adding custom doc type:', error);
      toast.error('Failed to add custom document type');
    }
  };

  const handleEditCustomDocType = async () => {
    if (!editDocTypeName.trim()) {
      toast.error('Please enter a document type name');
      
return;
    }

    try {
      await clientApi.editCustomClientDocType.index(clientId, selectedDocType.id, editDocTypeName.trim());
      await fetchCustomDocTypes()
      toast.success('Custom document type updated successfully');
      setShowEditModal(false);
      setSelectedDocType(null);
      setEditDocTypeName('');
    } catch (error) {
      console.error('Error updating custom doc type:', error);
      toast.error('Failed to update custom document type');
    }
  };

  const handleDeleteCustomDocType = async () => {
    try {
      await clientApi.deleteCustomClientDocType.index(clientId, selectedDocType.id);
      await fetchCustomDocTypes()
      toast.success('Custom document type deleted successfully');
      setShowDeleteModal(false);
      setSelectedDocType(null);
    } catch (error) {
        toast.error('Failed to delete custom document type');
      }
    
  };

  const openEditModal = (docType: any) => {
    setSelectedDocType(docType);
    setEditDocTypeName(docType.name);
    setShowEditModal(true);
  };

  const openDeleteModal = (docType: any) => {
    setSelectedDocType(docType);
    setShowDeleteModal(true);
  };

  return (
    <div className='custom-doc-types-section'>
      <h4>Custom Document Folders</h4>
      <div className='custom-doc-types-list'>
        {customDocTypes.length > 0 && (
          <div style={{ marginBottom: '1rem' }}>
            {customDocTypes.map((docType) => (
              <div 
                key={docType.id} 
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '8px',
                }}
              >
                <span style={{ fontSize: '14px', color: '#0d2330', marginRight: '12px' }}>
                  {docType.name}
                </span>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <button
                    className='action-icon edit-icon'
                    onClick={() => openEditModal(docType)}
                    title='Edit'
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: '4px',
                      color: '#0d2330',
                    }}
                  >
                    <i className='fa fa-pencil' aria-hidden='true' />
                  </button>
                  <button
                    className='action-icon delete-icon'
                    onClick={() => openDeleteModal(docType)}
                    title='Delete'
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: '4px',
                      color: '#dc3545',
                    }}
                  >
                    <i className='fa fa-trash' aria-hidden='true' />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
        {customDocTypes.length === 0 && (
          <p style={{ color: '#666', fontStyle: 'italic', marginBottom: '1rem' }}>
            No custom document folders created yet
          </p>
        )}
        <div style={{ display: 'block', clear: 'both' }}>
          <button className='create-button' onClick={() => setShowAddModal(true)}>
            <span className='plus-icon'>+</span>
            Create Custom Folder
          </button>
        </div>
      </div>

      {showAddModal && (
        <Modal
          title='Create Custom Document Folder'
          show={true}
          handleClose={() => {
            setShowAddModal(false);
            setNewDocTypeName('');
          }}
          handleSubmit={handleAddCustomDocType}
          submitBtnText='Create'
        >
          <div>
            <label htmlFor='docTypeName'>Folder Name</label>
            <input
              id='docTypeName'
              type='text'
              value={newDocTypeName}
              onChange={(e) => setNewDocTypeName(e.target.value)}
              placeholder='Enter folder name'
              style={{ width: '100%', marginTop: '8px' }}
            />
          </div>
        </Modal>
      )}

      {showEditModal && (
        <Modal
          title='Edit Custom Document Folder'
          show={true}
          handleClose={() => {
            setShowEditModal(false);
            setSelectedDocType(null);
            setEditDocTypeName('');
          }}
          handleSubmit={handleEditCustomDocType}
          submitBtnText='Save'
        >
          <div>
            <label htmlFor='editDocTypeName'>Folder Name</label>
            <input
              id='editDocTypeName'
              type='text'
              value={editDocTypeName}
              onChange={(e) => setEditDocTypeName(e.target.value)}
              placeholder='Enter folder name'
              style={{ width: '100%', marginTop: '8px' }}
            />
          </div>
        </Modal>
      )}

      {showDeleteModal && (
        <Modal
          title='Delete Custom Document Folder'
          show={true}
          handleClose={() => {
            setShowDeleteModal(false);
            setSelectedDocType(null);
          }}
          handleSubmit={handleDeleteCustomDocType}
          submitBtnText='Delete'
        >
          <p>
            Are you sure you want to delete the folder "<strong>{selectedDocType?.name}</strong>"?
            This action cannot be undone.
          </p>
        </Modal>
      )}
    </div>
  );
};

export default CustomDocTypesSection;
